import React, {useState} from 'react';
import {Button, Divider, Form, InputNumber, Row, Typography, Slider, Space, Input, Col, message, Switch} from "antd";
import { saveAs } from 'file-saver'
import {GLOBAL_CONFIG} from "../../tools/global_config";
import {track} from "@amplitude/analytics-browser";

const { Title, Text } = Typography;
const { TextArea } = Input;

const ResultParamsPanel = ({saving, loading, selectedResult, onSaveClickCallback, onCreateClickCallback}) => {

    const [feedback, setFeedback] = useState("");
    const [keepDepth, setKeepDepth] = useState(true);

    const [form] = Form.useForm();

    const [feedbackForm] = Form.useForm();

    const marks = {};
    let maxStep = Math.max(...selectedResult.intermediate_timesteps);
    let minStep = Math.min(...selectedResult.intermediate_timesteps);
    marks[maxStep] = "Similar";
    marks[minStep] = "Unlike";

    const downloadImage = (url) => {
        saveAs(url) // Put your image url here.
    }

    return (
        <div style={{width: 440}}>
            <Title
                level={5}
                style={{marginTop: 16, marginBottom: 16, marginLeft: 16, float: "left"}}
            >
                Diffusion parameters
            </Title>
            <Divider />
            {
                selectedResult.hasOwnProperty("url")
                    ?
                    <Space
                        direction="vertical"
                        size="middle"
                        style={{
                            display: 'flex',
                        }}
                    >
                        <Text
                            strong
                            style={{margin: "auto", width: "50%"}}>
                            {selectedResult.name}
                        </Text>
                        <div style={{marginBottom: 16}}>
                            <Button
                                type="link"
                                onClick={() => {
                                    downloadImage(selectedResult.url);
                                }}
                            >
                                Download
                            </Button>
                        </div>
                    </Space>
                    : <div/>
            }
            <Form
                form={form}
                labelCol={{
                    span: 6, offset: 1
                }}
                wrapperCol={{
                    span: 12, offset: 2
                }}
                labelAlign="right"
                layout="horizontal"
                initialValues={{
                    prompt: selectedResult.prompt,
                    results: 3,
                    similarity: minStep
                }}
            >
                <Form.Item name="prompt" label="Prompt">
                    <TextArea rows={3} disabled/>
                </Form.Item>
                <Form.Item name="results" label="Results">
                    <InputNumber min={1} max={10} style={{width: "100%"}}/>
                </Form.Item>
                <Form.Item name="similarity" label="Similarity" hidden={!selectedResult.intermediate_timesteps.length}>
                    <Slider
                        style={{width: "80%"}}
                        marks={marks}
                        min={minStep}
                        max={maxStep}
                        tooltip={{open: false}}
                    />
                </Form.Item>
                <Form.Item name="keep_depth" label="Keep geometry">
                    <Switch
                        value={keepDepth}
                        onChange={setKeepDepth}
                    />
                </Form.Item>
            </Form>
            <Button
                loading={saving}
                type="primary"
                style={{width: 256, marginTop: 16, marginBottom: 16, height: 40, borderRadius: 8}}
                onClick={() => {
                    let params = {
                        image_blob_path: selectedResult.output_path
                    }
                    onSaveClickCallback(params)
                }}
                disabled={selectedResult.hasOwnProperty("url") === false}
            >
                Save as asset
            </Button>
            <Button
                loading={loading}
                type="primary"
                style={{width: 256, marginTop: 16, marginBottom: 16, height: 40, borderRadius: 8}}
                onClick={() => {
                    let url = GLOBAL_CONFIG.sd_child_url
                    let goal = maxStep + minStep - form.getFieldValue("similarity");
                    let closest = selectedResult.intermediate_timesteps.reduce(function(prev, curr) {
                        return (Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);
                    });
                    let params = {
                        input_image_blob_path: selectedResult.output_path.split('/')[0],
                        keep_depth: keepDepth,
                        batch_size: form.getFieldValue("results"),
                        t_enc: closest
                    }
                    onCreateClickCallback(url, params)
                }}
                disabled={selectedResult.hasOwnProperty("url") === false}
                hidden={!selectedResult.intermediate_timesteps.length}
            >
                Generate similar
            </Button>
            <Divider />
            <Col>
                <Row>
                    <Title
                        level={5}
                        style={{marginTop: 16, marginBottom: 16, marginLeft: 24, float: "left"}}
                    >
                        Have a feedback on this result?
                    </Title>
                </Row>
                <Row>
                    <Text style={{marginLeft: 24, marginRight: 16, marginBottom: 16}}>
                        Fill the form below and send it to us.
                    </Text>
                </Row>
                <Row>
                    <Form
                        form={feedbackForm}
                        layout="horizontal"
                        style={{margin: "auto", width: "80%"}}
                        onValuesChange={(changedValues, allValues) => {
                            setFeedback(allValues["feedback"])
                        }}
                    >
                        <Form.Item name="feedback">
                            <TextArea rows={3}/>
                        </Form.Item>
                    </Form>
                </Row>
                <Row>
                    <Button
                        type="primary"
                        disabled={feedback == ""}
                        style={{marginLeft: 48, marginRight: 48, width: "100%", marginBottom: 32, height: 40, borderRadius: 8}}
                        onClick={() => {
                            track(
                                "inplace_feedback_clicked",
                                {
                                    "feedback" : feedbackForm.getFieldValue("feedback"),
                                    "prompt" : selectedResult.prompt,
                                    "url" : selectedResult.url
                                });
                            message.success("Thank you for your feedback!");
                            feedbackForm.setFieldValue("feedback", "");
                            setFeedback("");
                        }}
                    >
                        Send feedback
                    </Button>
                </Row>
            </Col>
        </div>
    );
};

export default ResultParamsPanel;